import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { GeofencingMgtService } from '../../../services/geofencing-mgt.service';
import { ConfirmModal } from '@app/shared/modals';
import { PermissionService } from '../../../services/permission.service';

interface GeofenceLocation {
  countryName: string;
  enabled: boolean;
}

@Component({
  selector: 'app-allowed-countries',
  templateUrl: './allowed-countries.component.html',
  styleUrls: ['./allowed-countries.component.scss'],
})
export class AllowedCountriesComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  success: any;
  error: any;
  locations: any = [];
  totalItems: number;
  totalItemsTwo: any;
  constructor(
    private permissionService: PermissionService,
    private modalService: SuiModalService,
    private geofenceSvc: GeofencingMgtService
  ) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });
    this.getLocation(1);
    this.totalItems = this.locations.length;
  }

  getLocation(page: number) {
    this.filter.page = page;
    this.pending = true;
    this.geofenceSvc
      .getGeofenceAllowedCountries({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.locations = res['rows'];
          this.totalItems = +res.records;
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }

  delete(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Allowed Geofence Location',
          'Are you sure you want to delete this allowed Geofence Location' +
            ' ' +
            `${user.countryName}`,
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        this.pending = true;
        this.geofenceSvc
          .deleteGeofenceCountry({
            geofenceCountryId: user.geoFenceCountryId,
          })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success = 'Location Deleted SuccessFully';
              setTimeout(() => {
                this.getLocation(1);
              }, 1500);
            },
            (error) => {
              this.pending = false;
              this.error = error.error ? error.error : error;
            }
          );
      })
      .onDeny(() => {});
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'profile',
          op: 'cn',
          data: '',
        },
        // {
        //   field: '',
        //   op: 'cn',
        //   data: '',
        // },
        // {
        //   field: 'location',
        //   op: 'cn',
        //   data: '',
        // },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getLocation(1);
  }

  ngOnInit(): void {}
  geofenceLocations: GeofenceLocation[] = [
    { countryName: 'Nigeria', enabled: true },
    { countryName: 'Ghana', enabled: true },
    { countryName: 'South Africa', enabled: true },
    { countryName: 'United States of America', enabled: true },
    { countryName: 'United Kingdom', enabled: true },
    { countryName: 'Canada', enabled: true },
  ];
  // totalItems = this.geofenceLocations.length;

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'desc';
    this.getLocation(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getLocation(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getLocation(this.currentPage);
  }

  toggleLocation(location: GeofenceLocation): void {
    location.enabled = !location.enabled;
  }

  checkPermission(event: { id: string; action: string }): boolean {
    const { id, action } = event;
    return this.permissionService.checkPermission(id, action);
  }
}
